<template>
    <v-layout row>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-btn
                    fab
                    dark
                    small
                    color="primary"
                    slot="activator"
            >
                <v-icon color="white">edit</v-icon>
            </v-btn>
            <v-card>

                <form v-on:submit.prevent="create">
                    <v-card-title>
                        <span class="headline">Edit priority sample order</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 s12 md12>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.name"
                                            :error-messages="errors.collect('data.name')"
                                            label="Name"
                                            data-vv-name="data.name"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                        <v-btn color="blue darken-1" flat type="submit">Edit</v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        props: ['status'],
        data: () => ({
            dialog: false,
            data: {
                name: '',
                id: ''
            }
        }),
        created () {
            this.data.name = this.status.name;
            this.data.id = this.status.id;
        },
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('editPrioritySampleOrders', this.data).then((res) => {
                            this.$emit('created');
                            this.data = {
                                name: this.status.name,
                                id: this.status.id
                            };
                            this.dialog = false
                        }).catch((error) => {

                        });
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data = {
                    name: this.status.name,
                    id: this.status.id
                };
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/admin/config/priorities/samples/components/EditModal.vue